module.exports = __webpack_public_path__ + "img/companyimg.eb856530.png";